/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable consistent-return */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Col, Overlay, Row } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import { useIntl } from 'react-intl';
import { MdArrowBackIos } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getHotelDetailsApi,
  getConversionRate,
  getWeatherForLocation,
  getRoomCancellationRulesApi,
  validateHotelPricingApi,
  getHotelDetailsApiV2,
} from '../../../api/hotelApi';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import {
  NAVIGATION_ROUTES,
  ONLY_DATE_FORMAT,
  MONTH_FORMAT,
  ONLY_DATE_MONTH_FORMAT,
  FARE_SOURCES,
} from '../../../shared/constants/Constants';
import {
  scrollToTop,
  formatDate,
  getNewDate,
  isNullOrEmpty,
} from '../../../shared/helper-utils/appUtils';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import NoSearchResults from '../../one-way/NoSearchResults';
import RoomOptions from './RoomOptions';
import HotelLocation from './HotelLocation';
import HotelSearch from '../hotel-search/HotelSearch';
import FacilityIcons from '../search-results/FacilityIcons';
import { useAppContext } from '../../../saas/AppConfigWrapper';

const displayCurrencys = [
  { label: 'Indian Rupees', value: 'INR' },
  { label: 'Dollars (U.S)', value: 'USD' },
  { label: 'Pounds Sterling', value: 'GBP' },
  { label: 'Euro', value: 'EUR' },
  { label: 'Australian Dollar', value: 'AUD' },
  { label: 'Dirham', value: 'AED' },
  { label: 'Singapore Dollar', value: 'SGD' },
  { label: 'Saudi Riyal', value: 'SAR' },
  { label: 'Kuwaiti dinar', value: 'KWD' },
  { label: 'South African Rand', value: 'ZAR' },
  { label: 'Algerian dinar', value: 'DZD' },
  { label: 'Qatari Riyal', value: 'QAR' },
];

function HotelDetailsV2() {
  const { appConfig } = useAppContext();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const location = useLocation();
  const [searchRequest, setSearchRequest] = useState({
    searchQuery: {
      checkIn: '',
      checkInSearch: '',
      checkOut: '',
      checkOutSearch: '',
      city: '',
      country: '',
      totRoomNights: 1,
      loggedInUserAgentId: '',
      customerCountry: '',
      paxCOR: '',
      isAminity: true,
      baseCurrency: appConfig?.appCurrency,
      totrooms: 1,
      totalPeople: 1,
      roomRequirements: [
        {
          adults: '1',
          childs: '0',
          childAges: '',
          infants: '0',
          infantAges: '',
        },
      ],
    },
    pagination: {
      currentPage: 0,
      pageSize: 40,
      stars: '',
      sortBy: '',
      hotelName: '',
      version: 'v2',
      minPrice: 0,
      propertyType: '',
      isPostpaid: '',
      maxPrice: 1000000,
    },
    cache: 6,
    searchV3: 'true',
    profileId: '',
    isSBT: '',
  });
  const [objForSearch, setObjForSearch] = useState(undefined);
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [hotelDetails, setHotelDetails] = useState({});
  const [isSearchDone, setSearchDone] = useState(false);
  const navigate = useNavigate();
  const [displayCurrency, setDisplayCurrency] = useState(
    appConfig?.appCurrency,
  );
  const [conversionRate, setConversionRate] = useState(1);
  const [amenities, setAmenities] = useState([]);
  const [weatherDetails, setWeatherDetails] = useState([]);
  const targetRefs = {
    otherRooms: useRef(null),
    overview: useRef(null),
    location: useRef(null),
    amenities: useRef(null),
    weather: useRef(null),
  };
  const [activeDiv, setActiveDiv] = useState('overview');
  const [totalNights, setTotalNights] = useState(0);
  const [detailsResponseId, setDetailsResponseId] = useState('');

  useEffect(() => {
    const options = {
      threshold: 0.5,
    };
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveDiv(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, options);

    Object.values(targetRefs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [targetRefs]);

  const getHotelDetails = async (request) => {
    setLoading(true);
    const response = await getHotelDetailsApiV2(request);

    if (
      response &&
      !isNullOrEmpty(response.propertyList) &&
      !isNullOrEmpty(response.propertyList[0])
    ) {
      setHotelDetails(response.propertyList[0]);
      setDetailsResponseId(response.detailsResponseId);
      //   let list = response.moreInfo.amenities;
      //   list = Array.isArray(list) ? list : [list];
      const res = await getWeatherForLocation(
        response.propertyList[0]?.lat,
        response.propertyList[0]?.lng,
      );
      if (res) {
        if (!res.hasOwnProperty('list')) {
          // no action
        } else {
          let { list } = res;
          if (list) list = Array.isArray(list) ? list : [list];
          const formattedList = list.slice(0, 6);
          setWeatherDetails(formattedList);
        }
      }
      //   setAmenities(list);
    } else {
      setAlert({
        variant: 'error',
        title: formattedMessage('hotel_bookings_details'),
        description: response?.Root?.Message,
      });
    }

    setLoading(false);
    scrollToTop();
    setSearchDone(true);
  };

  const getGrade = (avgRating) => {
    let grade = '';
    if (avgRating >= 4) {
      grade = formattedMessage('very_good');
    } else if (avgRating >= 3) {
      grade = formattedMessage('good');
    } else if (avgRating >= 2) {
      grade = formattedMessage('average');
    } else {
      grade = formattedMessage('poor');
    }
    return grade;
  };

  const getConvertedAmount = async (option) => {
    if (option === appConfig?.appCurrency) {
      setConversionRate(1);
      return true;
    }
    const response = await getConversionRate(getUserAgentId(), option);
    setConversionRate(response);
  };

  const handleRefClick = (ref) => {
    const headerHeight = 50;
    const targetTop =
      ref.current.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  };

  useEffect(() => {
    getConvertedAmount(displayCurrency);
  }, [displayCurrency]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const objString = params.get('detailsObj');
    if (objString) {
      const obj = JSON.parse(objString);
      const searchObj = {
        searchResponseId: obj.searchResponseId,
        pbKey: '',
        hotelCode: obj.propertyCode,
        isMapped: obj.isMapped,
        mappingSupplier: obj.mappingSupplier,
        contentFilter: 'none',
        clientId: '',
        checkIn: obj.checkIn,
        checkInSearch: obj.checkInSearch,
        checkOutSearch: obj.checkOutSearch,
        checkOut: obj.checkOut,
        city: obj.city,
        country: obj.country.trim(),
        faresource: obj.fareSource,
      };
      const totNights =
        (getNewDate(obj.checkOutSearch) - getNewDate(obj.checkInSearch)) /
        (1000 * 60 * 60 * 24);
      setTotalNights(totNights);
      setObjForSearch(searchObj);
      setSearchRequest(obj);
      getHotelDetails(obj);
    }
  }, [location]);

  const performReprice = async (selectedRoom) => {
    const searchObj = { ...searchRequest };

    const rePriceRequest = {
      detailsResponseId: detailsResponseId,
      searchResponseId: searchObj.searchResponseId,
      selectedRooms: [
        {
          bookingKey: selectedRoom.bookingKey,
        },
      ],
      checkIn: searchObj.checkIn,
      checkInSearch: searchObj.checkInSearch,
      checkOutSearch: searchObj.checkOutSearch,
      checkOut: searchObj.checkOut,
      city: searchObj.city,
      country: searchObj.country,
      faresource: selectedRoom.fareSource,
      nextratotalprice: selectedRoom.nextratotalprice,
    };
    try {
      setLoading(true);
      const res = await validateHotelPricingApi(rePriceRequest);
      if (res.statusCode === 200) {
        let roomDetails = res.propertyList[0].rooms;
        roomDetails = Array.isArray(roomDetails) ? roomDetails : [roomDetails];
        const updatedHotelDetails = {
          ...hotelDetails,
          supphold: res.propertyList[0].supphold,
          suppbalanceavailable: res.propertyList[0].suppbalanceavailable,
        };
        if (res.isPriceChanged) {
          navigate(NAVIGATION_ROUTES.HOTEL.REVIEW_BOOKING, {
            state: {
              hotelDetails: updatedHotelDetails,
              searchRequest,
              roomDetails: roomDetails[0],
              bookingDataKey: res.repriceResponseId,
              selectedRoom: selectedRoom,
              isPriceChanged: res.isPriceChanged,
            },
          });
        } else {
          navigate(NAVIGATION_ROUTES.HOTEL.REVIEW_BOOKING, {
            state: {
              hotelDetails: updatedHotelDetails,
              searchRequest,
              roomDetails: roomDetails[0],
              bookingDataKey: res.repriceResponseId,
              selectedRoom: selectedRoom,
              isPriceChanged: res.isPriceChanged,
            },
          });
        }
      } else {
        // navigate(NAVIGATION_ROUTES.HOTEL.REVIEW_BOOKING, {
        //   state: {
        //     hotelDetails,
        //     searchRequest,
        //     roomDetails: selectedRoom,
        //     bookingDataKey: res.repriceResponseId,
        //     selectedRoom: selectedRoom,
        //   },
        // });
        setAlert({
          variant: 'error',
          description:
            'Selected room is not available. Please choose a different room',
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setAlert({
        variant: 'error',
        description:
          'Selected room is not available. Please choose a different room',
      });
    }
  };

  const onRoomChoose = async () => {
    const selectedRoom = hotelDetails.rooms[0];
    await performReprice(selectedRoom);
    // navigate(NAVIGATION_ROUTES.HOTEL.REVIEW_BOOKING, {
    //   state: {
    //     hotelDetails,
    //     searchRequest,
    //     roomDetails: selectedRoom,
    //     bookingDataKey: hotelDetails.dataKey,
    //   },
    // });
    // const selectedRoom = hotelDetails.roomInfos[0];
    // if (FARE_SOURCES.indexOf(Number(selectedRoom.fareSource)) > -1) {
    //   await performReprice(selectedRoom);
    // } else {
    // }
  };

  const onParticularRoomChoose = async (roomInfo) => {
    // if (FARE_SOURCES.indexOf(Number(roomInfo.fareSource)) > -1) {
    // }
    await performReprice(roomInfo);
    // navigate(NAVIGATION_ROUTES.HOTEL.REVIEW_BOOKING, {
    //   state: {
    //     hotelDetails,
    //     searchRequest,
    //     roomDetails: roomInfo,
    //     bookingDataKey: hotelDetails.dataKey,
    //   },
    // });
  };

  const formatCurrency = (amount) => {
    const convertedAmount = amount * conversionRate;
    return `${displayCurrency} ${Math.round(convertedAmount)}`;
  };

  const getCancellationCharges = async () => {
    getRoomCancellationRulesApi();
  };

  return (
    <section>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {/* {searchRequest &&
        objForSearch &&
        searchRequest.searchQuery.checkInSearch &&
        searchRequest.searchQuery.checkOutSearch && (
          <div className="modify-hotel-search hide-in-mobile">
            <div className="modify-hotel-search_container">
              <HotelSearch previousSearchRequest={objForSearch} />
            </div>
          </div>
        )} */}
      {isSearchDone &&
        (Object.keys(hotelDetails).length > 0 ? (
          <div className="hotel-details-page-container">
            <div className="hotel-details-page_bredcrum-navigation show-in-mobile ">
              {/* <span onClick={() => navigate(-2)}>
                {formattedMessage('home')}
              </span>
              <MdArrowForwardIos /> */}
              <span onClick={() => navigate(-1)}>
                <MdArrowBackIos /> {formattedMessage('hotels_in')}{' '}
                {searchRequest.city}
              </span>
              {/* <MdArrowForwardIos />
              <span className="primary-color">{hotelDetails.propertyName}</span> */}
            </div>
            <div className="hotel-details-page__body">
              <Row className="spacing-8">
                <Col lg={7} md={7} sm={7}>
                  <div>
                    <Carousel className="details-page-carousal">
                      {Array.isArray(hotelDetails?.images) &&
                      hotelDetails.images.length > 0 ? (
                        hotelDetails.images.map((d, index) => (
                          <Carousel.Item key={index}>
                            <img
                              src={d.url}
                              alt={formattedMessage('room')}
                              className="hotel-details-page__body__banner-image"
                              onError={(e) => {
                                const fallback =
                                  '/images/others/hotel-empty.jpg';
                                if (!e.target.src.includes(fallback)) {
                                  e.target.src = fallback;
                                }
                              }}
                            />
                          </Carousel.Item>
                        ))
                      ) : (
                        <Carousel.Item>
                          <img
                            src="/images/others/hotel-empty.jpg"
                            alt={formattedMessage('room')}
                            className="hotel-details-page__body__banner-image"
                          />
                        </Carousel.Item>
                      )}
                    </Carousel>
                  </div>
                </Col>
                <Col
                  className="hotel-details-page__body__highlights-container"
                  lg={5}
                  md={5}
                  sm={5}
                >
                  <div className="hotel-details-page__body_summary">
                    <div className="hotel-details-page__body_summary_hotel-details d-flex justify-content-between">
                      <div className="d-flex flex-column w-75">
                        <span className="fs-16 fw-600">
                          {hotelDetails.propertyName}
                        </span>
                        {/* <span className="fs-12">
                          {formattedMessage('for')}{' '}
                          {searchRequest.searchQuery.totalPeople}{' '}
                          {formattedMessage('people')}
                        </span> */}
                        {/* <div className="d-flex gap-1 flex-wrap">
                          <span className="amenities-pill">Non-Refundable</span>
                        </div> */}
                      </div>
                      <div className="d-flex flex-column flex-sm-column align-items-start align-items-sm-end">
                        <span className="fs-10 text-start text-sm-end">
                          For {totalNights} Night(s)
                        </span>
                        <span className="fs-16 fw-500 text-start text-sm-end">
                          {formatCurrency(hotelDetails.minPrice)}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className="flex-1 other-rooms-link d-flex"
                        onClick={() => handleRefClick(targetRefs.otherRooms)}
                      >
                        {formattedMessage('other_rooms')}
                      </div>
                      <div
                        className="book-now-link flex-1"
                        onClick={onRoomChoose}
                      >
                        {formattedMessage('book_now')}
                      </div>
                    </div>
                  </div>
                  <div className="hotel-details-page__body_summary mt-3">
                    <div className="hotel-details-page__body_summary_rating p-3">
                      {hotelDetails.starRating !== '' && (
                        <div className="d-flex gap-3 mb-3">
                          <span className="details-star-rating">
                            {hotelDetails.starRating}
                          </span>
                          <div className="d-flex align-items-start flex-column ps-3 justify-content-center">
                            <span className="details-rating-grade">
                              {getGrade(hotelDetails.starRating)}
                            </span>
                            {/* <span className="details-user-ratings">
                              Based on 300 Ratings
                            </span> */}
                          </div>
                        </div>
                      )}
                      <div className="d-flex justify-content-between">
                        <div className="check-in-out-card">
                          <span className="fs-10">
                            {formattedMessage('check_in')}
                          </span>
                          <span className="fw-600">
                            {formatDate(
                              getNewDate(searchRequest.checkInSearch),
                              ONLY_DATE_FORMAT,
                            )}
                          </span>
                          <span className="fs-10">
                            {formatDate(
                              getNewDate(searchRequest.checkInSearch),
                              MONTH_FORMAT,
                            )}
                          </span>
                        </div>
                        <div className="check-in-out-card">
                          <span className="fs-10">
                            {formattedMessage('check_out')}
                          </span>
                          <span className="fw-600">
                            {formatDate(
                              getNewDate(searchRequest.checkOutSearch),
                              ONLY_DATE_FORMAT,
                            )}
                          </span>
                          <span className="fs-10">
                            {formatDate(
                              getNewDate(searchRequest.checkOutSearch),
                              MONTH_FORMAT,
                            )}
                          </span>
                        </div>
                        <div className="check-in-out-card">
                          <span className="fs-10">
                            {formattedMessage('room')} {searchRequest.totrooms}
                          </span>
                          <span className="fw-600">
                            {searchRequest.totalPeople}
                          </span>
                          <span className="fs-10">
                            {formattedMessage('gusest')}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            {/* <Row className="my-2 px-3">
              <Col lg={3} md={4} sm={6} xs={12}>
                <AppSelect
                  label="Currency"
                  name="currencyoption"
                  placeholder="Currency"
                  options={displayCurrencys}
                  selectedValue={displayCurrency}
                  onSelect={(data) => setDisplayCurrency(data.value)}
                  isClearable={false}
                />
              </Col>
            </Row> */}
            <div className="d-flex gap-2 flex-wrap details-tab-container z-2">
              <button
                onClick={() => handleRefClick(targetRefs.overview)}
                className="details-tab"
              >
                {formattedMessage('overview')}
              </button>
              <button
                onClick={() => handleRefClick(targetRefs.otherRooms)}
                className="details-tab"
              >
                {formattedMessage('rooms')}
              </button>
              <button
                onClick={() => handleRefClick(targetRefs.location)}
                className="details-tab"
              >
                {formattedMessage('location')}
              </button>
              <button
                onClick={() => handleRefClick(targetRefs.amenities)}
                className="details-tab"
              >
                {formattedMessage('amenities')}
              </button>
              <button
                onClick={() => handleRefClick(targetRefs.weather)}
                className="details-tab"
              >
                {formattedMessage('weather')}
              </button>
            </div>
            <div className="px-2">
              <div
                className="mb-3  border-top pt-1"
                ref={targetRefs.overview}
                id="overview"
              >
                <div className="fs-16 fw-600">
                  {formattedMessage('overview')}
                </div>
                <div
                  className="hotel-details-page__body__overview-text pt-1 fs-12"
                  dangerouslySetInnerHTML={{
                    __html: hotelDetails?.description,
                  }}
                />
              </div>
              <div
                className="mb-3  border-top pt-1"
                ref={targetRefs.otherRooms}
                id="otherRooms"
              >
                <RoomOptions
                  roomOptions={hotelDetails.rooms || []}
                  thumbnail={hotelDetails.thumbnail}
                  onRoomChoose={onParticularRoomChoose}
                  currencyOption={displayCurrency}
                  conversionRate={conversionRate}
                  searchRequest={searchRequest}
                  totalNights={totalNights}
                />
              </div>
              <div
                className="mb-3  border-top pt-1"
                id="location"
                ref={targetRefs.location}
              >
                <div className="fs-16 fw-600">
                  {formattedMessage('map_and_location')}
                </div>
                <div className="fs-12 fw-500 mb-1">
                  {hotelDetails.propertyName}{' '}
                  {formattedMessage('has_been_rated')} {hotelDetails.starRating}{' '}
                  {formattedMessage('out_of')} 5
                </div>
                <HotelLocation
                  lat={Number(hotelDetails.lat)}
                  lng={Number(hotelDetails.lng)}
                  name={hotelDetails.propertyName}
                />
              </div>
              <div
                className="mb-3 border-top pt-1"
                id="amenities"
                ref={targetRefs.amenities}
              >
                <div className="fs-16 fw-600 mb-2">
                  {formattedMessage('amenities_at')} {hotelDetails.propertyName}
                </div>
                <div className="d-flex gap-2 flex-wrap">
                  <FacilityIcons hotelData={hotelDetails} showTitle={true} />
                </div>
              </div>
              <div
                className="mb-3 border-top pt-1"
                id="weather"
                ref={targetRefs.weather}
              >
                {weatherDetails.length > 0 && (
                  <>
                    <div className="fs-16 fw-600">
                      {formattedMessage('weather_in')} {searchRequest.city}
                    </div>
                    <div className="d-flex flex-wrap gap-3">
                      {weatherDetails.length > 0 &&
                        weatherDetails.map((d) => (
                          <div
                            key={d.dt_txt}
                            className="weather-card d-flex flex-column justify-content-between"
                          >
                            <div>
                              <span>{}</span>
                              <span>{d.dt_txt.split(' ')[1]}</span>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <img
                                src={`http://openweathermap.org/img/wn/${d.weather[0].icon}.png`}
                                alt=""
                              />
                              <span>{d.weather[0].description}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                {formatDate(
                                  getNewDate(d.dt_txt.split(' ')[0]),
                                  ONLY_DATE_MONTH_FORMAT,
                                )}
                              </span>

                              <span className="fs-10">
                                {(d.main.temp_max - 273).toFixed(2)}
                                <sup>o</sup>C/
                                {(d.main.temp_min - 273).toFixed(2)}
                                <sup>o</sup>C
                              </span>
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="hotel-details-page-container">
            <NoSearchResults
              title={formattedMessage('hotel_details')}
              message={formattedMessage('failed_to_load_details')}
            />
          </div>
        ))}
    </section>
  );
}

HotelDetailsV2.defaultProps = {};

HotelDetailsV2.propTypes = {};

export default HotelDetailsV2;
